
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
//import { createPinia } from 'pinia';
import './assets/main.css'
//import 'video.js/dist/video-js.css';
import {getLocalMediaService} from '@/services/LocalMediaServices'
import store from './store'

getLocalMediaService()

let plataform = (navigator.userAgent)
const app = createApp(App)
//const pinia = createPinia();
app.config.globalProperties.$LastPosition = 20
app.config.globalProperties.$RadioProgramada = ''
//app.use(pinia);
app.use(router)
app.use(store)
app.mount('#app')

// El Service Worker es registrado y gestionado por usePwaUpdate.js
// a través de useRegisterSW (virtual:pwa-register/vue).
// No se necesita registro manual aquí.
